import type { Breadcrumb } from "@sentry/nextjs"
import { scrubSentryBreadcrumb as scrubCore } from "@webscraping/observability/scrub-breadcrumb"

export function scrubSentryBreadcrumb(breadcrumb: Breadcrumb | null): Breadcrumb | null {
  return scrubCore(breadcrumb)
}
